export const GEIST_FONT = 'Geist';
export const SPACE_GROTESK_FONT = 'Space Grotesk';
